// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useState} from 'react';
import styles from './product_landing.module.less';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import Icon_google from '../../../../util/pub/img/icon_google2.svg';
import cn from 'classnames';
import {perr} from 'hola_pub_util';
import {use_login} from '../navbar/use_login';
import {App_context} from 'hola_app_context';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Editor} from '../../../../shared/editor/editor';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

interface i_product_hero_props {
    title: string;
    title_tag?: string;
    sub_title: string;
    cta: string;
    id: string;
    img: string;
}

interface i_product_hero_props_editor {
    value: i_product_hero_props;
    on_change: (v:i_product_hero_props)=>void;
    on_cancel: ()=>void;
}

export const Product_hero_editor = (props:i_product_hero_props_editor)=>{
    const [state, set_state] = useState<i_product_hero_props>(props.value);
    return <Editor
      value={state}
      editors={[
        {key: 'title', label: 'Title', type: 'text'},
        {key: 'title_tag', label: 'Title Tag', type: 'select_tag_selector'},
        {key: 'sub_title', label: 'Sub title', type: 'text'},
        {key: 'cta', label: 'CTA text', type: 'text'},
        {key: 'id', label: 'id (for metrics)', type: 'text'},
        {key: 'img', label: 'Img link', type: 'text'},
      ]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}/>;
};

export const Product_hero = (props:i_product_hero_props)=>{
    const {user} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {on_signup} = use_login(true, '/dashboard');
    const scroll_to_pricing = ()=>{
        perr({id: `toolip_products_landing_cta_click_${props.id}`});
        const pricing_widget =
          document.querySelector('[class*=pricing_container]');
        if (pricing_widget)
          pricing_widget.scrollIntoView({behavior: 'smooth'});
    };
    return <div className={cn(styles.hero, theme.container)}>
      <div className={cn(styles.hero_text)}>
      <Dynamic_heading
        tag={props.title_tag || 'h1'}
        className={theme.H2}
        dangerouslySetInnerHTML={{__html: props.title}}/>
        <p className={cn(theme.u1)}
          dangerouslySetInnerHTML={{__html: props.sub_title}}/>
        <div className={cn(styles.hero_buttons)}>
          <Button caption={<Fragment>
            {props.cta}<Icon_arrow_right />
            </Fragment>} size={'lg'} round={false} no_jump
            fit color="black" cls={styles.hero_cta}
            on_click={scroll_to_pricing}/>
          {!user && <Button caption={<Fragment>
            <Icon_google width={16} height={16}/> <T>Sign Up with google</T>
            </Fragment>} size={'lg'} round={false} no_jump
            fit color="transparent_black" cls={styles.hero_signup}
            on_click={event=>{
              perr({id: `toolip_products_landing_signup_click_${props.id}`});
              on_signup(event);
            }}/>}
        </div>
      </div>
      <img src={props.img}/>
    </div>;
};
